// removed by extract-text-webpack-plugin
module.exports = {"container":"la_g"};


//////////////////
// WEBPACK FOOTER
// ./app/src/components/Tooltip/styles.module.css
// module id = 1149
// module chunks = 27